import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import filters from './plugins/filters'
import router from './router'
import store from './store'
import i18n from './plugins/i18n'
import Vuelidate from 'vuelidate'
import VueNoty from 'vuejs-noty'
import axios from 'axios'
import moment from 'moment'
import VueFilterDateFormat from 'vue-filter-date-format'
import CKEditor from '@ckeditor/ckeditor5-vue'
import 'vuejs-noty/dist/vuejs-noty.css'
import VueLayers from 'vuelayers'
import 'vuelayers/lib/style.css'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import UUID from 'vue-uuid'

Vue.use(UUID)
Vue.use(VueLayers)
Vue.component('auth-layout', () => import('@/layouts/AuthLayout'))
Vue.component('empty-layout', () => import('@/layouts/EmptyLayout'))
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)

Vue.use(VueNoty)
Vue.use(Vuelidate)
Vue.use(moment)
Vue.use(CKEditor)

Vue.use(VueFilterDateFormat, {
  dayOfWeekNames: [
    'Воскресенье',
    'Понедельник',
    'Вторник',
    'Среда',
    'Четверг',
    'Пятница',
    'Суббота'
  ],
  dayOfWeekNamesNamesShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  monthNames: [
    'Январь(-я)',
    'Февраль(-я)',
    'Март(-а)',
    'Апрель(-я)',
    'Май(-я)',
    'Июнь(-я)',
    'Июль(-я)',
    'Август(-а)',
    'Сентябрь(-я)',
    'Октябрь(-я)',
    'Ноябрь(-я)',
    'Декабрь(-я)'
  ],
  monthNamesShort: [
    'Янв',
    'Фев',
    'Мар',
    'Апр',
    'Май',
    'Июн',
    'Июл',
    'Авг',
    'Сен',
    'Окт',
    'Ноя',
    'Дек'
  ]
})

Vue.prototype.$http = axios
const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common.Authorization = `Bearer ${token}`
}

axios.defaults.baseURL = process.env.VUE_APP_BACK_URL
axios.defaults.headers.post['Content-Type'] = 'application/json'

axios.interceptors.request.use(function (config) {
  if (config.url.includes('api/public')) {
    if (!config.url.includes('/api/public/user/current')) {
      delete config.headers.common.Authorization
    }
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response.status === 401) {
      store.dispatch('logout')
    }

    return Promise.reject(error)
  }
)

new Vue({
  vuetify,
  filters,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
